import React, { useMemo } from 'react'
import { useFeatureFlags } from '@usap/core'
import NoItemsInCart from '../NoItemsInCart'
import Title from '../Title'
import Details from '../Details'
import * as Styled from './WrapperWmo.css'
import CartDataHasChanged from '../Notification/CartDataHasChanged'
import VendorItemsAddFailed from '../Notification/VendorItemsAddFailed'

import PopUpProvider from '../../providers/PopUpProvider'
import PopUps from '../PopUps'
import ItemsExceededStock from '../Notification/ItemsExceededStock'
import { usef40flag } from '../../../../hooks/constructor'

const WrapperWmo = ({
  items, showLoader, cartData, isCartDataMerged, vendorItemsAddFailed, tooltip,
}) => {
  const decisions = useFeatureFlags()
  const isFlagEnabled = useMemo(() => usef40flag(decisions), [decisions])
  return (
    <Styled.Container isFlagEnabled={isFlagEnabled}>
      {vendorItemsAddFailed && (
        <Styled.CartBox>
          <VendorItemsAddFailed />
        </Styled.CartBox>
      )}
      {((!items || items.length < 1) && !showLoader) && <NoItemsInCart />}

      {(items && items.length > 0) && (
      <Styled.CartBox data-testid="cart-box">
        <PopUpProvider>
          <PopUps data={cartData} />
          <Title />
          <ItemsExceededStock />
          {isCartDataMerged && <CartDataHasChanged />}
          <Details data={cartData} tooltip={tooltip} showLoader={showLoader} />
        </PopUpProvider>
      </Styled.CartBox>
      )}
    </Styled.Container>
  )
}

export default WrapperWmo
